import { BaseEvent, BaseSystemMessage } from '../../types';
import {
  MatchedChatTrigger,
  ResolveTrigger,
  TriggerMatchListener,
} from './ChatTrigger.types';
import * as PleasedApi from '@/common/api/api.pleased';
import { getChatTriggerReport } from './ChatTrigger.utils';
import { noop } from '../ChatFramework.utils';
import { TransactionTypeName } from '@/common/transaction-utils';
import { TransStatement } from '@/common/api/model';

export async function checkTrigger (
  {
    type,
    id,
    triggerEvent,
    triggerMessage,
    userCountry,
  }: {
    type: 'CATEGORY' | 'ARTICLE' | 'SECTION';
    id: number | string;
    triggerEvent: BaseEvent | null;
    triggerMessage: BaseSystemMessage | null;
    userCountry: string;
  },
  onMatch: TriggerMatchListener
): Promise<void | MatchedChatTrigger> {
  return PleasedApi.matchOverlayTrigger
    .cached({ type, id: +id, userCountry })
    .then(matchedTrigger => {
      if (!matchedTrigger?.message?.length) return;
      const { chatTriggerId } = matchedTrigger;

      let resolveTrigger: ResolveTrigger | undefined;
      const triggerResolver = new Promise<'END_CHAT' | 'CONTINUE'>(resolve => {
        resolveTrigger = resolve;
      });

      const trigger = {
        ...matchedTrigger,
        matchSource: type,
        triggerEvent,
        triggerMessage,
        report: getChatTriggerReport({ chatTriggerId, resolveTrigger }),
        waitForResolution: () => triggerResolver,
      };

      onMatch(trigger);

      return trigger;
    })
    .catch(noop);
}

export const manualTriggerCheck = checkTrigger;

export async function checkTransactionTrigger (
  {
    userCountry,
    transactionType,
    transaction,
  }: {
    userCountry: string;
    transactionType: TransactionTypeName;
    transaction: TransStatement;
  },
  onMatch: TriggerMatchListener
): Promise<void | MatchedChatTrigger> {
  return PleasedApi.matchTransactionTrigger({
    userCountry,
    transactionType,
    transaction,
  })
    .then(matchedTrigger => {
      console.log('matchedTrigger', matchedTrigger);
      if (!matchedTrigger?.message?.length) return;
      const { chatTriggerId } = matchedTrigger;

      let resolveTrigger: ResolveTrigger | undefined;
      const triggerResolver = new Promise<'END_CHAT' | 'CONTINUE'>(resolve => {
        resolveTrigger = resolve;
      });

      const trigger = {
        ...matchedTrigger,
        report: getChatTriggerReport({ chatTriggerId, resolveTrigger }),
        waitForResolution: () => triggerResolver,
        triggerMessage: null,
        triggerEvent: null,
        matchSource: null,
      };

      onMatch(trigger);

      return trigger;
    })
    .catch(noop);
}

export const manualTransactionTriggerCheck = checkTransactionTrigger;
